<template>
	<div
		class="post-preview-card elevation-0 d-flex flex-column pt-3"
		v-if="this.post.user"
		style="padding-right: 0 !important; padding-left: 0 !important"
	>
		<div class="post-preview-card__container">
			<div class="post-preview-card__outer">
				<div
					:style="{ paddingTop: post.sponsored_by ? '38px' : '12px' }"
					class="d-flex post-preview-card__list pl-0 pr-0"
				>
					<SponsorBadge
						v-if="sponsoredLabel"
						:text="sponsoredLabel"
						:top="'0px'"
						:right="'0px'"
						:icon="'star'"
						:iconSize="10"
						:iconColor="'#ffffff'"
					/>
					<div class="post-preview-card__avatar-wrapper px-3">
						<router-link
							:to="{
								name: isCurrentUser(this.post.user.user_id)
									? 'profile'
									: 'user-by-id',
								params: isCurrentUser(this.post.user.user_id)
									? []
									: { id: this.post.user.user_id },
							}"
							class="d-flex align-center text-decoration-none"
							:class="{ disabled: this.post.user.user_hidden }"
						>
							<Avatar
								class="mr-2 post-preview-card__avatar"
								:size="50"
								:avatar="this.post.user.user_logo"
							/>
							<div class="d-flex flex-column">
								<span class="post-preview-card__meta">
									{{ this.post.user.visible_username }}
								</span>
								<span
									v-if="this.post.user.second_profile_row"
									class="post-preview-card__meta-bottom mt-2"
								>
									{{ this.post.user.second_profile_row }}
								</span>
							</div>
						</router-link>

						<div
							class="post-preview-card__time-container"
							:style="{
								justifyContent: post.pin_to_top ? 'space-between' : 'flex-end',
							}"
						>
							<Icon v-if="post.pin_to_top" color="var(--badge-pin-background)" :size="16" type="pinned" />
							<span class="post-preview-card__meta-time">{{ dateCreated }}</span>
						</div>
					</div>
					<div
						class="pa-0 pt-3 post-preview-card__thumbnail-outer"
						v-if="
							!isPollPost &&
								(
                    (post.slider_images && post.slider_images.length) ||
                      post.thread_image ||
                      isYoutubeVideo ||
                      isVimeoVideo
                 )
						"
					>
						<div class="slider-container" v-if="isTextPost || isPollPost">
							<button v-if="slideButtons" class="prev-btn" @click="prevSlide">
								❮
							</button>

							<div class="slider">
								<img
									class="post-preview-card__thumbnail"
									:src="photos[currentIndex]"
									alt="thread image"
									loading="lazy"
									@error="handleImageError"
									@click="openModal"
								/>
							</div>

							<button v-if="slideButtons" class="next-btn" @click="nextSlide">
								❯
							</button>
							<div v-if="post.slider_images.length > 1" class="dots-container">
								<span
									v-for="(photo, index) in photos"
									:key="index"
									class="dot"
									:class="{ active: index === currentIndex }"
									@click="goToSlide(index)"
								></span>
							</div>
						</div>

						<div
							v-if="isPreviewVimeoModeActive"
							class="post-preview-card__thumbnail__vimeo"
						>
							<img
								class="post-preview-card__thumbnail"
								:src="this.post.thread_image"
								alt="thread image"
								loading="lazy"
								@error="handleImageError"
							/>
							<span @click="playVideo"></span>
						</div>
						<iframe
							style="padding: 0 12px"
							v-if="!isPreviewVimeoModeActive && isVimeoVideo"
							:src="formateVimeoVideoLink"
							width="600"
							height="338"
							:ref="createUniqueIframeName(this.post)"
							allow="autoplay; encrypted-media"
							allowfullscreen
							@load="iframeLoaded"
						></iframe>
						<div
							v-if="isPreviewYoutubeModeActive"
							class="post-preview-card__thumbnail__youtube"
						>
							<img
								class="post-preview-card__thumbnail"
								:src="this.post.thread_image"
								alt="thread image"
								loading="lazy"
								@error="handleImageError"
							/>
							<span @click="playVideo"></span>
						</div>
						<iframe
							style="padding: 0 12px"
							v-if="!isPreviewYoutubeModeActive && isYoutubeVideo"
							:src="formateYoutubeVideoLink"
							width="600"
							height="338"
							:ref="createUniqueIframeName(this.post)"
							allow="autoplay; encrypted-media"
							@load="iframeLoaded"
							allowfullscreen
						></iframe>
					</div>
					<div
						v-if="post && post.thread_title"
						class="post-preview-card__title pb-0 pt-3 px-3 u-cursor-pointer"
						@click="toggleToPost"
					>
						{{ this.post.thread_title }}
					</div>
					<v-card-text v-if="post.thread_text" class="px-3 post-preview-card__content">
						<div
							@click="toggleToPost"
							:style="{ paddingTop: post.thread_title ? '8px' : '12px' }"
							ref="contentInner"
							class="post-preview-card__content-inner u-cursor-pointer"
							:class="{ collapsed: !isExpanded && isContentTooLong }"
							v-html="postDescription(post.thread_text)"
						></div>
						<div v-if="!isExpanded && isContentTooLong" class="fade-overlay"></div>
						<div class="d-flex justify-end">
							<v-btn
								height="22"
								v-if="isContentTooLong"
								text
								@click="toggleExpand"
								class="post-preview-card__content-inner__button_see_more"
							>
								{{ isExpanded ? 'Hide Post' : 'See More' }}
							</v-btn>
						</div>
					</v-card-text>
          <LinkInfo
              v-if="!isPollPost && (metadata || threadActionLink)"
              @toggleLink="toggleLink"
              :metadata="metadata"
              :threadActionTitle="threadActionTitle"/>
					<Poll
						v-if="isPollPost && post.poll"
						:poll="post.poll"
						:postId="post.thread_id"
						:post="post"
            :typeValue="'feed'"
					/>
					<div v-if="!isPollPost && post.uploads && post.uploads.length">
						<router-link
							style="text-decoration: unset"
							:to="{
								name: 'post-file-by-id',
								params: { id: this.post.thread_id },
								query: {
									enable_all_comments: enableAllComments ? 1 : 0,
									thread_menu_id: thread_menu_id,
								},
							}"
						>
							<div class="d-flex align-center px-3 pt-3">
								<div
									v-for="attachment in post.uploads.slice(0, 6)"
									:key="attachment.upload_id"
									class="attachment-wrapper"
								>
									<PostAttachments
										backgroundColor="#F3F3F6"
										:attachment="attachment"
									/>
								</div>
								<div
									v-if="post.uploads.length > 6"
									class="more-attachments"
									style="cursor: pointer"
								>
									+{{ countAttachments }}
								</div>
							</div>
						</router-link>
					</div>
					<div
						class="post-preview-card__tags px-3 pt-3"
						v-if="this.post.tags.length !== 0"
					>
						<div
							class="post-preview-card__tags-container d-flex justify-start flex-wrap"
						>
							<span
								class="post-preview-card__tag__more"
								v-for="(tag, index) in this.tagShowArray"
								:key="index"
								@click="onTagClick(tag.tag_id)"
							>
								#{{ tag.tag }}
							</span>
							<span
								v-if="this.post.tags.length > 2 && !showAllTags"
								@click="tagsShow"
								class="post-preview-card__tag__more"
							>
								+ {{ countTags }} more
							</span>
							<span
								v-if="showAllTags"
								@click="tagsShow"
								style="width: 67px"
								class="post-preview-card__tag__more"
							>
								Hide
							</span>
						</div>
					</div>

					<v-divider class="my-3" />
					<div class="d-flex align-center justify-space-between pb-3 px-3">
						<div class="d-flex">
							<button
								type="button"
								class="post-preview-card__like-btn elevation-0 pa-0"
								@click="onLike"
								v-if="enableLikesButton"
							>
								<Icon
									:pr="4"
									type="hearth"
									:size="24"
									:color="isLiked ? 'var(--text_button_tint)' : '#9b9b9b'"
								/>
								<span
									v-if="displayLikes"
									:class="
										isLiked
											? 'post-preview-card__like-counter-active'
											: 'post-preview-card__like-counter'
									"
								>
									{{ this.likes }}
								</span>
							</button>
							<button
								type="button"
								class="post-preview-card__like-btn elevation-0 pa-0 ml-4"
								@click="toggleToPost"
							>
								<Icon type="comment" :pr="4" :size="24" color="#9b9b9b" />
								<span
									v-if="
										enableAllComments && allowComments && displayCommentsCount
									"
									class="post-preview-card__like-counter"
								>
									{{ this.commentsCount }}
								</span>
							</button>
						</div>

						<div class="d-flex justify-end">
							<div
								v-if="displayViews"
								class="d-flex align-center justify-center mr-4"
								style="width: 64px"
							>
								<Icon type="eye" :size="24" color="#9b9b9b" :pr="4" />
								<span class="post-preview-card__like-counter">
									{{ this.post.view_count }}
								</span>
							</div>
							<span
								@click="onFollow"
								class="post-preview-card__like-button d-flex align-center"
								style="cursor: pointer; user-select: none"
							>
								<Icon
									v-if="isFollowed"
									type="bookmark"
									:size="24"
									color="var(--text_button_tint)"
								/>
								<Icon v-else type="bookmark_empty" :size="24" color="#9b9b9b" />
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<PhotoModal v-if="isModalOpen" :post="post" @close="isModalOpen = false" />
		<v-dialog v-model="mobileLink" max-width="588px" width="100%" persistent>
			<v-card class="exhibitor-page__modal">
				<div class="exhibitor-page__modal__title">
					This screen is not available in the Web App, but you can access it through the
					mobile app
				</div>
				<button
					type="button"
					@click="toggleCloseMobileLink"
					class="exhibitor-page__modal__btn"
				>
					OK
				</button>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import { toggleDislike, toggleFollow, toggleLike, toggleUnFollow } from '@/api/post'
import { mapActions, mapGetters } from 'vuex'
import Avatar from '@/components/Avatar'
import pinnedIcon from '@/assets/images/icon-pinned.svg'
import sponsoredStarIcon from '@/assets/images/icon-sponsored-star.svg'
import PostAttachments from '@/components/Post/PostAttachments'
import CommentForm from '@/components/Forms/CommentForm.vue'
import Poll from '@/components/Post/Poll.vue'
import Dwh from '@/mixins/Dwh'
import PhotoModal from '@/components/PhotoModal.vue'
import linkifyThreadText from '@/mixins/linkifyThreadText'
import SponsorBadge from '@/components/SponsorBadge.vue'
import LinkInfo from "@/components/LinkInfo.vue"

Vue.use(VueScrollTo)

const THREAD_VIDEO_TYPE = 3
const VIDEO_TYPE_YOUTUBE = 1
const VIDEO_TYPE_VIMEO = 2
const THREAD_POLL_TYPE = 4

export default {
	components: {
		SponsorBadge,
		PhotoModal,
		CommentForm,
		Avatar,
		PostAttachments,
		Poll,
    LinkInfo,
	},
	mixins: [Dwh, linkifyThreadText],
	props: {
		post: {
			type: Object,
			default: () => ({}),
		},
		displayViews: {
			type: Boolean,
			default: false,
		},
		displayLikes: {
			type: Boolean,
			default: false,
		},
		enableLikesButton: {
			type: Boolean,
			default: false,
		},
		displayCommentsCount: {
			type: Boolean,
			default: false,
		},
		thread_menu_id: {
			type: Number,
			default: 0,
		},
    selectedChips:{
      type: Object,
      default: () => ({}),
    }
	},
	data() {
		return {
			mobileLink: false,
			metadata: null,
			isModalOpen: false,
			showAllTags: false,
			attachment: {
				url: '',
			},
			currentIndex: 0,
			isContentTooLong: false,
			isExpanded: false,
			offset: true,
			isLiked: false,
			isFollowed: false,
			likes: 0,
			commentsCount: 0,
			enableAllComments: false,
			notAvailableImage: require('@/assets/images/image_not_available.png'),

			previewMode: true,
			iframeElement: null,

			pinnedIcon,
			sponsoredStarIcon,
			avatar: 'https://e7.pngegg.com/pngimages/799/987/png-clipart-computer-icons-avatar-icon-design-avatar-heroes-computer-wallpaper-thumbnail.png',
			titleImage:
				'https://images.familyhomeplans.com/cdn-cgi/image/fit=contain,quality=100/plans/44207/44207-b1200.jpg',
		}
	},
	mounted() {
		this.fetchMetadata()
		this.$nextTick(() => {
			this.checkContentHeight()
		})
	},
	computed: {
		...mapGetters('auth', ['isAuthenticated', 'profile', 'mapRegisterToken']),
		...mapGetters('auth', ['profile', 'isAuthenticated']),
		...mapGetters('settings', ['appCore']),
		sponsoredLabel() {
			const sponsor = this.post.sponsored_by
			if (!sponsor) return ''

			const limitedSponsor = sponsor.length > 30 ? sponsor.slice(0, 30) + '…' : sponsor

			return `Sponsored by ${limitedSponsor}`
		},
		tagShowArray() {
			if (!this.showAllTags) {
				return this.post.tags.slice(0, 2)
			} else {
				return this.post.tags
			}
		},
		countAttachments() {
			if (Array.isArray(this.post.uploads)) {
				return this.post.uploads.length - 6
			}
			return 0
		},
		countTags() {
			if (Array.isArray(this.post.tags)) {
				return this.post.tags.length - 2
			}
			return 0
		},
		photos() {
			if (this.post.slider_images) {
				return this.post.slider_images.map((image) => image.image_url)
			}
			return []
		},

		slideButtons() {
			return this.photos.length > 1
		},
		dateCreated() {
			const date = new Date(this.post.publish_timestamp * 1000)
			const options = { year: 'numeric', month: 'long', day: 'numeric' }
			return date.toLocaleDateString('en-US', options)
		},
		allowComments() {
			return !!this.post.allow_comments
		},
		formateVimeoVideoLink() {
			const { thread_video_code: code } = this.post || {}

			const additionalParams = '?autoplay=1&mute=1'

			if (this.isVimeoVideoWithPreviewImage) {
				return `https://player.vimeo.com/video/${code}${additionalParams}`
			}

			return `https://player.vimeo.com/video/${code}`
		},
		formateYoutubeVideoLink() {
			const { thread_video_code: code } = this.post || {}

			const additionalParams = '?autoplay=1&mute=1'

			if (this.isYoutubeVideoWithPreviewImage) {
				return `https://www.youtube.com/embed/${code}${additionalParams}`
			}

			return `https://www.youtube.com/embed/${code}`
		},
		isYoutubeVideoWithPreviewImage() {
			const {
				thread_type: type,
				thread_image: image,
				thread_video_type: videoType,
			} = this.post || {}

			return type === THREAD_VIDEO_TYPE && videoType === VIDEO_TYPE_YOUTUBE && image
		},
		isVimeoVideoWithPreviewImage() {
			const {
				thread_type: type,
				thread_image: image,
				thread_video_type: videoType,
			} = this.post || {}

			return type === THREAD_VIDEO_TYPE && videoType === VIDEO_TYPE_VIMEO && image
		},
		isVimeoVideo() {
			const { thread_type: type, thread_video_type: videoType } = this.post || {}

			return type === THREAD_VIDEO_TYPE && videoType === VIDEO_TYPE_VIMEO
		},
		isYoutubeVideo() {
			const { thread_type: type, thread_video_type: videoType } = this.post || {}

			return type === THREAD_VIDEO_TYPE && videoType === VIDEO_TYPE_YOUTUBE
		},
		isPreviewVimeoModeActive() {
			if (this.isVimeoVideoWithPreviewImage) {
				if (this.previewMode) {
					return true
				}
			}

			return false
		},
		isPreviewYoutubeModeActive() {
			if (this.isYoutubeVideoWithPreviewImage) {
				if (this.previewMode) {
					return true
				}
			}

			return false
		},

		isTextPost() {
			return this.post.thread_type !== THREAD_VIDEO_TYPE
		},

		isPollPost() {
			return this.post.thread_type === THREAD_POLL_TYPE
		},
		threadActionVisible() {
			return (
				this.post.threadActions.length &&
				!!this.post.threadActions[0].action_link &&
				!!this.post.threadActions[0].action_title
			)
		},
		threadActionTitle() {
			return this.threadActionVisible ? this.post.threadActions[0].action_title : null
		},
		threadActionLink() {
			if (!this.threadActionVisible) return null

			const link = this.post.threadActions[0].action_link
			const isExternal = link.includes('http://') || link.includes('https://')

			if (isExternal) return link
			const match = link.match(/:\/\/(.*)/)
			if (!match) return link

			let routePart = match[1]
			const needsAuthPrefix = [
				'restore-password',
				'login',
				'register',
				'welcome',
				'role-selection',
			]
			const [firstSegment] = routePart.split('/')
			if (needsAuthPrefix.includes(firstSegment)) {
				routePart = `auth/${routePart}`
			}

			return `${window.location.origin}/webapp/${routePart}`
		},
	},
	methods: {
		...mapActions('post', ['getPost', 'deletePost']),
		...mapActions('auth', ['getMapRegisterToken']),
    tagChoices(id){
      if (!this.selectedChips || !this.selectedChips.tags) return false
      return this.selectedChips.tags.includes(id)
    },
		toggleToPost() {
			if (this.post.thread_type === 2) {
				this.$router.push({
					name: 'forum-by-id',
					params: { id: this.post.thread_id },
				})
			} else {
				this.$router.push({
					name: 'posts-by-id',
					params: { id: this.post.thread_id },
					query: {
						enable_all_comments: this.enableAllComments ? 1 : 0,
						thread_menu_id: this.thread_menu_id,
					},
				})
			}
		},
		async toggleLink() {
			const target = this.metadata?.url || this.threadActionLink

			if (!target) return

			if (this.isUnsupportedDeepLink(target)) {
				this.mobileLink = true
				return
			}

			if (this.isMapUrlValid(target)) {
				try {
					await this.getMapRegisterToken()
					if (!this.mapRegisterToken) {
						console.error('Token not received')
						return
					}
					const urlWithToken = `${target}${target.includes('?') ? '&' : '?'}code=${
						this.mapRegisterToken
					}`
					window.open(urlWithToken, '_self')
				} catch (e) {
					console.error(e)
				}
			} else {
				window.open(target, '_self')
			}
		},
		toggleCloseMobileLink() {
			this.mobileLink = false
		},
		onTagClick(tagId) {
			this.$emit('tagClicked', tagId)
		},
		async fetchMetadata() {
			if (!this.post.thread_link) return

			try {
				const response = await fetch(this.post.thread_link, { mode: 'cors' })
				const html = await response.text()

				const parser = new DOMParser()
				const doc = parser.parseFromString(html, 'text/html')

				this.metadata = {
					title:
						doc.querySelector("meta[property='og:title']")?.content ||
						doc.title ||
						'',
					description:
						doc.querySelector("meta[property='og:description']")?.content ||
						this.getDisplayLink(this.post.thread_link),
					image: doc.querySelector("meta[property='og:image']")?.content || null,
					url: this.post.thread_link,
				}
			} catch (error) {
				console.error(error)
				this.metadata = {
					title: '',
					description: this.getDisplayLink(this.post.thread_link),
					image: null,
					url: this.post.thread_link,
				}
			}
		},
		openModal() {
			this.isModalOpen = true
		},
		applySelection() {
			this.$emit('applySelection')
		},
		tagsShow() {
			this.showAllTags = !this.showAllTags
		},
		nextSlide() {
			this.currentIndex = (this.currentIndex + 1) % this.photos.length
		},
		prevSlide() {
			this.currentIndex = (this.currentIndex - 1 + this.photos.length) % this.photos.length
		},
		goToSlide(index) {
			this.currentIndex = index
		},

		checkContentHeight() {
			const contentEl = this.$refs.contentInner
			if (contentEl) {
				const lineHeight = parseFloat(window.getComputedStyle(contentEl).lineHeight)
				const height = contentEl.scrollHeight
				const numLines = Math.floor(height / lineHeight)
				this.isContentTooLong = numLines > 5
			}
		},
		toggleExpand() {
			this.isExpanded = !this.isExpanded
		},
		isCurrentUser(userId) {
			if (!this.profile) {
				return false
			}
			const { user_id: currentUserId } = this.profile
			return userId === currentUserId
		},
		handleImageError() {
			this.post.thread_image = this.notAvailableImage
		},
		createUniqueIframeName(post) {
			const { thread_video_code: videoCode } = post || {}

			return `videoIframe_${videoCode}`
		},
		playVideo() {
			this.previewMode = false
		},
		iframeLoaded() {
			const { thread_video_code: code } = this.post || {}

			this.iframeElement = this.$refs[`videoIframe_${code}`]
		},
		getDisplayLink(rawLink) {
			if (!rawLink) {
				return ''
			}
			if (rawLink.startsWith('com.pinxterapp.dev.clowder-core://')) {
				return window.location.origin
			}
			try {
				const urlObj = new URL(rawLink)
				let domain = urlObj.hostname
				if (!domain.startsWith('www.')) {
					domain = 'www.' + domain
				}
				return domain
			} catch (error) {
				return rawLink
			}
		},
		onLike() {
			if (this.isLiked) {
				if (this.likes === 0) {
					return
				}
				this.likes--
				toggleDislike(this.post.thread_id)
			} else if (!this.isLiked) {
				this.likes++
				toggleLike({ thread_id: this.post.thread_id })
				this.sendTrigger({
					category: 'Content',
					action: 'click_like_news_post',
					module: 'News Feed',
					data: this.post.thread_id,
					title: this.post.thread_title,
					content_chapter_id: this.post.chapter_id ? [this.post.chapter_id] : null,
				})
			}

			this.isLiked = !this.isLiked
		},
		onFollow() {
			if (this.isFollowed) {
				toggleUnFollow(this.post.thread_id)
			} else if (!this.isFollowed) {
				toggleFollow({ thread_id: this.post.thread_id })
				this.sendTrigger({
					category: 'Content',
					action: 'click_bookmark_news_post',
					module: 'News Feed',
					data: this.post.thread_id,
					title: this.post.thread_title,
					content_chapter_id: this.post.chapter_id ? [this.post.chapter_id] : null,
				})
			}

			this.isFollowed = !this.isFollowed
		},
	},

	created() {
		if (this.post) {
			this.likes = this.post.upvote_count
			this.commentsCount = this.post.comments_count
			this.isLiked = this.post.upvote
			this.isFollowed = this.post.follow
		}

		if (+this.$route.query.enable_all_comments) {
			this.enableAllComments = true
		}
	},
}
</script>

<style lang="scss">
.fade-overlay {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 30px;
}

.post-preview-card {
	background: #f1f1f1 !important;

	&__time-container {
		height: 50px;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: flex-end;
	}

	&__tags-container {
		gap: 8px;
	}

	&__link-wrapper {
		padding: 12px 12px 0 12px;
	}

	&__container {
		width: 100%;
		height: 100%;
		border-radius: 10px !important;
		background: white !important;
	}

	&__content-inner {
		font-family: Inter, sans-serif;
		font-weight: 400;
		font-size: 16px;
		line-height: 140%;
		letter-spacing: 0;
		padding-top: 8px;
		color: #4a4a4a;

		&__button_see_more {
			padding: unset !important;
			text-transform: none;

			.v-btn__content {
				font-family: Inter, sans-serif;
				font-weight: 700;
				font-size: 18px;
				line-height: 100%;
				letter-spacing: 0;
				text-align: center;
				color: var(--text_button_tint)!important;
				text-transform: none;
			}
		}

		&.collapsed {
			display: -webkit-box;
			-webkit-line-clamp: 5;
			-webkit-box-orient: vertical;
			overflow: hidden;
		}

		img {
			width: 100%;
		}

		span {
			white-space: normal;
		}

		p {
			margin-bottom: 16px !important;
      &:last-child {
        margin-bottom: 0 !important;
      }
		}

		h1 {
			font-size: 30px;
			padding-bottom: 8px;
			line-height: 30px;
		}

		a {
			line-height: 100% !important;
			letter-spacing: 0 !important;
			font-family: Inter, sans-serif !important;
			font-size: 16px !important;
			font-weight: 400 !important;
			color: var(--link) !important;
			text-decoration: none !important;
		}
	}

	&__meta {
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 18px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--username-category-title);
		justify-content: space-between;
		word-break: break-word;

		&-bottom {
			max-width: 350px;
			width: 100%;
			font-family: Inter, sans-serif;
			font-weight: 400;
			font-size: 15px;
			line-height: 20px;
			letter-spacing: 0;
			color: var(--company-position-large);
			word-break: break-word;
		}

		&-time {
			color: rgb(155, 155, 155);
			font-size: 12px;
			font-family: Inter, sans-serif;
			font-weight: normal;
			text-align: right;
			white-space: nowrap;
		}
	}

	&__avatar {
		border-radius: 8px;

		img {
			object-fit: cover;
		}

		&-wrapper {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
	}

	&__list {
		border: 1px solid #e2e2e2;
		border-radius: 8px;
		position: relative;
		flex-direction: column;
	}

	&__title {
		color: var(--username-category-title);
		font-size: 20px;
		font-family: Inter, sans-serif;
		font-weight: 700;
		letter-spacing: 0;
		line-height: 22px;
		font-style: normal;

		a {
			color: #002855 !important;
			text-decoration: none;
			font-family: Inter, sans-serif !important;
			font-weight: 700 !important;
			font-size: 20px !important;
			line-height: 22px !important;
			letter-spacing: 0 !important;
		}
	}

	&__block-view {
		flex-direction: column;
		height: 73%;

		.post-preview-card__thumbnail-outer img {
			max-width: 100%;
		}
	}

	&__content {
		font-family: Inter, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 21px;
	}

	&__thumbnail {
		max-height: 311px;
		height: 100%;
		width: 100%;
		object-fit: cover;
		border-radius: 8px;

		&-outer iframe {
			width: 100% !important;
		}
	}

	&__tag {
		padding: 6px;
		font-size: 14px !important;
		font-family: Inter, sans-serif;
		font-weight: normal;
		border-radius: 20px !important;
		border: 1.5px solid #e2e2e2 !important;
		height: 20px !important;
		cursor: pointer;
		background-color: #ffffff !important;

		span {
			min-width: 100% !important;
			width: 100%;
			font-family: 'Inter', sans-serif;
			font-weight: 400;
			font-size: 13px;
			color: #4a4a4a;
		}

		&__more {
			width: fit-content;
			padding: 6px;
			display: flex;
			align-items: center;
			height: 26px;
			justify-content: center;
			font-family: 'Inter', sans-serif;
			font-weight: 400;
			font-size: 13px;
			color: #4a4a4a!important;
			border: 1.5px solid #e2e2e2;
			border-radius: 20px;
			cursor: pointer;
      &.tag-selected {
        background-color: var(--secondary_color) !important;
        color: #ffffff !important;
        border-color: var(--secondary_color);
      }

      &.tag-default {
        background-color: #ffffff !important;
        color: #4a4a4a !important;
      }
		}
	}

	&__like-btn {
		display: flex;
		align-items: center;
		gap: 6px;
		background-color: transparent !important;
	}

	&__like-counter {
		color: #9b9b9b !important;
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;

		&-active {
			font-size: 13px;
			font-family: Inter, sans-serif;
			font-weight: bold;
			color: var(--text_button_tint) !important;
		}
	}

	&__share-button {
		font-family: 'Inter', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		color: #aaaaaa !important;
		cursor: pointer;

		.v-icon {
			transform: rotateY(180deg);
		}

		&:hover {
			span {
				color: #757575;
				text-decoration: underline;
			}
		}
	}

	&__book-button {
		color: var(--accent-color);
		font-size: 14px;
		font-family: 'Inter', sans-serif;
		font-weight: bold;
		text-decoration: none;

		@media (max-width: 360px) {
			display: none;
		}

		&-active {
			color: #a0a0a0 !important;
			text-decoration: underline;
		}
	}

	&__comment {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		letter-spacing: -0.43px;
		width: 100%;

		&::placeholder {
			color: rgb(160, 160, 160);
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			letter-spacing: -0.43px;
		}

		&:focus {
			outline: none;
		}

		&-send {
			width: 38px;
			height: 22px;
			color: rgb(160, 160, 160);
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			text-decoration: underline;
			cursor: pointer;
		}
	}

	&__comments-button {
		cursor: pointer;

		&:hover {
			span {
				text-decoration: underline;
			}
		}
	}

	&__my-menu {
		margin-top: 20px;
		min-width: 175px !important;
		contain: initial !important;
		overflow: visible !important;

		&:before {
			content: '';
			position: absolute;
			left: 14px;
			top: 0;
			z-index: -1;
			border-radius: 3px;
			transform: translate(0, -50%) rotate(45deg);
			width: 20px;
			height: 20px;
			background: #fff;
			box-shadow: 0 0 11px rgb(0 0 0 / 14%);
		}
	}

	&__menu-dots {
		margin-left: 10px !important;
	}

	&__thread-action {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: space-between;
		text-decoration: none;
		padding: 0 16px 8px 16px;
		border-bottom: 1px solid #eaeaea;

		&-title {
			color: var(--accent-color);
			font-family: Montserrat, sans-serif;
			font-size: 14px;
			font-weight: 700;
			line-height: 22px;
			text-decoration: underline;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
		}

		&-icon {
			color: #cecece !important;
		}
	}

	@media screen and (max-width: 1904px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 75%;
		}
	}
	@media screen and (max-width: 1264px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 66%;
		}
	}

	@media screen and (min-width: 1264px) {
		&__container {
			max-width: 600px;
		}
	}
	@media screen and (max-width: 768px) {
		&__thumbnail {
			height: 100%;
			max-width: 100%;
		}
		&__default-thumbnail {
			max-height: 250px;
			height: 100%;
		}
		&__outer {
			flex-direction: column;
		}
	}
}

.dropdown-profile {
	padding: 15px;

	&__item {
		min-height: 30px !important;
		padding: 0;
	}

	&__title {
		color: #aaaaaa;
		font-size: 12px !important;
		line-height: 1.4 !important;
		font-family: 'Montserrat', sans-serif !important;
		font-weight: 600 !important;
	}

	&__title:hover {
		text-decoration: underline;
		color: black;
		transition: color 0.2s, background-color 0.2s, border-color 0.2s !important;
	}
}

.post-preview-card__thumbnail__youtube,
.post-preview-card__thumbnail__vimeo {
	padding: 0 12px;
	position: relative;
}

.post-preview-card__thumbnail__youtube span,
.post-preview-card__thumbnail__vimeo span {
	position: absolute;
	top: 50%;
	left: 50%;
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 20px 0 20px 30px;
	border-color: transparent transparent transparent #b3b2b2;
	cursor: pointer;
	transition: border-color 0.2s ease-in-out, border-width 0.2s ease-in-out;

	transform: translate(-50%, -50%);
}

.post-preview-card__thumbnail__youtube span:hover,
.post-preview-card__thumbnail__vimeo span:hover {
	border-color: transparent transparent transparent #d8d5d5ff;
	border-width: 30px 0 30px 40px;
}

iframe {
	border: none;
}

.disabled {
	pointer-events: none;
}

.slider-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	margin: auto;
	position: relative;
	border-radius: 8px;

	.prev-btn,
	.next-btn {
		opacity: 0;
		pointer-events: none;
	}

	&:hover .prev-btn,
	&:hover .next-btn {
		color: #f3f3f6;
		opacity: 1;
		pointer-events: all;
	}
}

.slider {
	width: 100%;
	max-height: 350px;
	height: 100%;
	padding: 0 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	border-radius: 8px;
	@media (max-width: 480px) {
		height: 250px;
	}
}

.prev-btn,
.next-btn {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	color: unset;
	border: none;
	cursor: pointer;
	font-size: 18px;
}

.prev-btn {
	left: 0;
}

.next-btn {
	right: 0;
}

.prev-btn:hover,
.next-btn:hover {
	color: #f3f3f6;
	z-index: 10;
}

.dots-container {
	display: flex;
	justify-content: center;
	margin-top: 10px;
	gap: 8px;
}

.dot {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #ccc;
	cursor: pointer;
	transition: background-color 0.3s ease;
}

.more-attachments {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 40px;
	height: 40px;
	border-radius: 20px;
	border: 1.5px solid #e2e2e2;
	font-family: Inter, sans-serif;
	font-weight: 400;
	font-size: 13px;
	line-height: 15.73px;
	color: #4a4a4a;
}

.dot.active {
	background-color: #002855;
}
</style>
